import React, { useState } from 'react';
import { PostModel } from '../../NewsfeedModels';
import { Text } from 'library';
import { Popover } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { track } from 'shared/Tracking';
import { SmallIconButton } from 'library';

export default function ViewMore({ post }: { post: PostModel }) {
    const [anchorEl, setAnchorEl] = useState<any>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        track('Posts: View more clicked', { post });
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        track('Posts: View more closed', { post });
        setAnchorEl(null);
    };
    const navigateToMessages = () => {
        track('Posts: Navigate To Messages', { post });
    };

    return post.user.role === 'PROVIDER' ? (
        <>
            <SmallIconButton onClick={handleClick} icon={MoreVert} />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div style={{ padding: 10 }}>
                    <Link to={`/messages/${post.user.id}`} onClick={navigateToMessages}>
                        <Text variant="body2" bold textStyle={{ textDecoration: 'underline' }}>
                            Message
                        </Text>
                    </Link>
                </div>
            </Popover>
        </>
    ) : (
        <></>
    );
}
